import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import SanctionList from "./SanctionList";
import * as sanctionThunks from "../../../../redux/thunks/sanctionThunks";
import sanctionActions from "../../../../redux/reducers/sanctionReducer/sanctionActions";

const SanctionListContainer = ({
  tournamentEditing,
  organizerId,
  tournamentId,
  loading,
  loadSanctions,
  sanctions,
  clearAllSanctions,
  setSanctionKeyValue,
  deleteSanction,
  show,
}) => {
  const DEFAULT_PAGE_SIZE = 25;
  const DEFAULT_PAGE = 0;

  useEffect(() => {
    clearAllSanctions();
    if (tournamentEditing) {
      loadSanctions(DEFAULT_PAGE, DEFAULT_PAGE_SIZE, organizerId, tournamentId);
    }
  }, []);

  const onRefreshUsers = (page, pageSize) => {
    clearAllSanctions();
    if (tournamentEditing) {
      loadSanctions(page, pageSize, organizerId, tournamentId);
    }
  };

  const deleteSanctionHandler = (sanctionId) =>
    deleteSanction(organizerId, tournamentId, sanctionId);

  return (
    show && (
      <SanctionList
        sanctions={sanctions}
        setSanctionKeyValue={setSanctionKeyValue}
        deleteSanction={deleteSanctionHandler}
        organizerId={organizerId}
        tournamentId={tournamentId}
        loadingFetchSanctions={loading.sanction.loadSanction}
        loadingDeleteSanction={loading.sanction.deleteSanction}
        defaultPage={DEFAULT_PAGE}
        defaultPageSize={DEFAULT_PAGE_SIZE}
        onRefreshUsers={onRefreshUsers}
      />
    )
  );
};

const mapState = (state) => ({
  loading: state.loading,
  sanctions: state.sanction.all,
  sanction: state.sanction.single,
});

const mapDispatch = (dispatch) => ({
  loadSanctions: (page, pageSize, organizerId, tournamentId) =>
    dispatch(
      sanctionThunks.loadSanctions(page, pageSize, organizerId, tournamentId)
    ),
  clearAllSanctions: () => dispatch(sanctionActions.clearAllSanctions()),
  setSanctionKeyValue: (key, value) =>
    dispatch(sanctionActions.setSanctionKeyValue(key, value)),
  deleteSanction: (organizerId, tournamentId, sanctionId) =>
    dispatch(
      sanctionThunks.deleteSanction(organizerId, tournamentId, sanctionId)
    ),
});

export default withRouter(
  connect(mapState, mapDispatch)(SanctionListContainer)
);
